
import dates from "@/mixins/dates"

export default {
    name: "ArticleDateTime",
    mixins: [dates],
    props: {
        startDate: {
            type: String,
            required: true,
        },
        endDate: {
            type: String,
            required: true,
        },
    },
    methods: {
        getTime(dateStr) {
            return this.toTime(dateStr)
        },
        getMonth(dateStr) {
            return this.formatDate(dateStr, { month: "short" })
        },
        getWeekday(dateStr) {
            return this.formatDate(dateStr, { weekday: "long" })
        },
    },
}
